import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/[locale]/(Knowledge Base)/news/[slug]/PostPage.client.tsx");
